// @flow
import { QuestionTypesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    questionType: {},
    listaQuestionTypes: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type QuestionTypesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { questionType?: {} | null, listaQuestionTypes?: [] | null, loading?: boolean, +value ?: boolean };

const QuestionTypes = (state: State = INIT_STATE, action: QuestionTypesAction): any => {
    // console.log(action);
    switch (action.type) {
        case QuestionTypesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case QuestionTypesActionTypes.GET_QUESTION_TYPE: {
                    return {
                        ...state,
                        questionType: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionTypesActionTypes.LIST_QUESTION_TYPES: {
                    return {
                        ...state,
                        listaQuestionTypes: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionTypesActionTypes.ADD_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesActionTypes.UPDATE_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesActionTypes.DELETE_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionTypesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case QuestionTypesActionTypes.GET_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        questionType: {},
                        loading: false,
                    };
                }
                case QuestionTypesActionTypes.LIST_QUESTION_TYPES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaQuestionTypes: [],
                        loading: false,
                    };
                }
                case QuestionTypesActionTypes.ADD_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesActionTypes.UPDATE_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionTypesActionTypes.DELETE_QUESTION_TYPE: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionTypesActionTypes.GET_QUESTION_TYPE:
            return { ...state, error: false, loading: true };
        case QuestionTypesActionTypes.LIST_QUESTION_TYPES:
            return { ...state, error: false, loading: true };
        case QuestionTypesActionTypes.ADD_QUESTION_TYPE:
            return { ...state, error: false, loadingForm: true };
        case QuestionTypesActionTypes.UPDATE_QUESTION_TYPE:
            return { ...state, error: false, loadingForm: true };
        case QuestionTypesActionTypes.DELETE_QUESTION_TYPE:
            return { ...state, error: false, loading: true };
        case QuestionTypesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                questionType: {},
                listaQuestionTypes: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default QuestionTypes;
